module.exports = __webpack_public_path__ + "img/Picture11.29bbef14.png";